import React, { useState } from 'react';
import axios from 'axios';

const RegisterModal = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [address, setAddress] = useState('');

  // Error State
  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    // Email Regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      tempErrors.email = "Invalid email format";
      isValid = false;
    }

    // Password Match
    if (password !== confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }
    if (password.length < 6) {
      tempErrors.password = "Password must be at least 6 characters";
      isValid = false;
    }


    if (address.length < 11) {
      tempErrors.address = "Phone number must be at least 11 digits";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleRegister = (e) => {
    e.preventDefault();

    if (!validate()) return; // Stop if invalid

    const newUser = { name, email, password, phone: address };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/register`, newUser)
      .then(res => {
        document.getElementById('registerModalCloseBtn').click();
        alert('Registration Successful! Please Login.');
        setName(''); setEmail(''); setPassword(''); setConfirmPassword(''); setAddress(''); setErrors({});
      })
      .catch(err => {
        console.error(err);
        alert(err.response?.data?.message || 'Error registering.');
      });
  };

  return (
    <div className="modal fade" id="registerModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={handleRegister}>
            <div className="modal-header">
              <h5 className="modal-title"><i className="bi bi-person-lines-fill fs-3 me-2"></i> Patient Registration</h5>
              <button type="reset" id="registerModalCloseBtn" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Name</label>
                  <input type="text" className="form-control shadow-none" value={name} onChange={(e) => setName(e.target.value)} required />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className={`form-control shadow-none ${errors.email ? 'is-invalid' : ''}`} value={email} onChange={(e) => setEmail(e.target.value)} required />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>
                <div className="col-md-12 mb-3">
                  <label className="form-label">Phone Number</label>
                  <input type="number" className={`form-control shadow-none ${errors.address ? 'is-invalid' : ''}`} value={address} onChange={(e) => setAddress(e.target.value)} placeholder="03001234567" required />
                  {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Password</label>
                  <input type="password" className={`form-control shadow-none ${errors.password ? 'is-invalid' : ''}`} value={password} onChange={(e) => setPassword(e.target.value)} required />
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Confirm Password</label>
                  <input type="password" className={`form-control shadow-none ${errors.confirmPassword ? 'is-invalid' : ''}`} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                  {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                </div>
              </div>
              <button type="submit" className="btn btn-warning w-100 fw-bold">Register</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;